import React from 'react'
import Icon from '@mui/icons-material/ForwardToInboxOutlined'
import { SvgIconProps } from '@mui/material/SvgIcon'

const ForwardToInboxIcon = (props: SvgIconProps) => <Icon fontSize="small" {...props} />

export default ForwardToInboxIcon
export {}
